import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function SaveHighlightDialog({ pending, onClose, testidPrefix = "bp" }) {
  const [note, setNote] = useState("");
  const close = () => { setNote(""); onClose(); };
  const save = async () => {
    try {
      await api.post("/highlights", { ...pending, note });
      toast.success("Highlight saved");
      close();
    } catch { toast.error("Could not save highlight"); }
  };
  return (
    <Dialog open={!!pending} onOpenChange={(v) => !v && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-display">Save highlight</DialogTitle>
          <DialogDescription>From: <span className="font-semibold text-slate-800">{pending?.source_title}</span></DialogDescription>
        </DialogHeader>
        <div className="p-3 rounded-lg bg-[#FFF7E8] border border-[#F5A623] text-sm text-slate-800 italic">"{pending?.text}"</div>
        <Input data-testid={`${testidPrefix}-highlight-note`} placeholder="Add a personal note (optional)" value={note} onChange={(e) => setNote(e.target.value)} />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={close}>Cancel</Button>
          <Button data-testid={`${testidPrefix}-highlight-save`} onClick={save} className="bg-[#0A2A5E] hover:bg-[#0F3F8A] text-white">Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
